// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./design-system.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><circle cx=\"50\" cy=\"50\" r=\"2\" fill=\"rgba%28255,255,255,0.1%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  /* Legacy CSS Custom Properties - Mapped to new design system */
  :root {
    --background: var(--color-background);
    --foreground: var(--color-foreground);
    --card: var(--color-card);
    --card-foreground: var(--color-card-foreground);
    --popover: var(--color-popover);
    --popover-foreground: var(--color-popover-foreground);
    --primary: var(--color-primary);
    --primary-foreground: var(--color-primary-foreground);
    --secondary: var(--color-secondary);
    --secondary-foreground: var(--color-secondary-foreground);
    --muted: var(--color-muted);
    --muted-foreground: var(--color-muted-foreground);
    --accent: var(--color-accent);
    --accent-foreground: var(--color-accent-foreground);
    --destructive: var(--color-destructive);
    --destructive-foreground: var(--color-destructive-foreground);
    --border: var(--color-border);
    --input: var(--color-input);
    --ring: var(--color-ring);
    --radius: 0.75rem;

    /* Document Analysis Specific Variables - Updated */
    --doc-primary-gradient: var(--gradient-primary);
    --doc-secondary-gradient: var(--gradient-success);
    --doc-success-gradient: var(--gradient-success);
    --doc-accent-gradient: var(--gradient-rainbow);
  }

  .dark {
    /* Legacy mapping maintained for backward compatibility */
    --background: var(--color-background);
    --foreground: var(--color-foreground);
    --card: var(--color-card);
    --card-foreground: var(--color-card-foreground);
    --popover: var(--color-popover);
    --popover-foreground: var(--color-popover-foreground);
    --primary: var(--color-primary);
    --primary-foreground: var(--color-primary-foreground);
    --secondary: var(--color-secondary);
    --secondary-foreground: var(--color-secondary-foreground);
    --muted: var(--color-muted);
    --muted-foreground: var(--color-muted-foreground);
    --accent: var(--color-accent);
    --accent-foreground: var(--color-accent-foreground);
    --destructive: var(--color-destructive);
    --destructive-foreground: var(--color-destructive-foreground);
    --border: var(--color-border);
    --input: var(--color-input);
    --ring: var(--color-ring);

    /* Dark mode document analysis gradients */
    --doc-primary-gradient: var(--gradient-primary);
    --doc-secondary-gradient: var(--gradient-success);
    --doc-success-gradient: var(--gradient-success);
    --doc-accent-gradient: linear-gradient(135deg, #434343 0%, hsl(var(--color-background)) 100%);
  }
  * {
  border-color: hsl(var(--color-border));
}
  body {
  background-color: hsl(var(--color-background));
  color: hsl(var(--color-foreground));
    font-feature-settings: "rlig" 1, "calt" 1;
}
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {

  .\\!container {
    max-width: 1400px !important;
  }

  .container {
    max-width: 1400px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-left-16 {
  left: -4rem;
}
.-right-1 {
  right: -0.25rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-16 {
  top: -4rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-24 {
  bottom: 6rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\/2 {
  right: 50%;
}
.right-10 {
  right: 2.5rem;
}
.right-12 {
  right: 3rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-32 {
  top: 8rem;
}
.top-4 {
  top: 1rem;
}
.top-8 {
  top: 2rem;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[55\\] {
  z-index: 55;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.m-2 {
  margin: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mr-16 {
  margin-right: -4rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100dvh\\] {
  height: 100dvh;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[calc\\(100vh-8rem\\)\\] {
  height: calc(100vh - 8rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-20 {
  max-height: 5rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[350px\\] {
  min-height: 350px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[700px\\] {
  min-height: 700px;
}
.min-h-\\[70vh\\] {
  min-height: 70vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[900px\\] {
  min-height: 900px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[calc\\(100vw-2rem\\)\\] {
  width: calc(100vw - 2rem);
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-\\[2rem\\] {
  min-width: 2rem;
}
.min-w-\\[44px\\] {
  min-width: 44px;
}
.min-w-\\[56px\\] {
  min-width: 56px;
}
.min-w-fit {
  min-width: fit-content;
}
.max-w-24 {
  max-width: 6rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[50px\\] {
  max-width: 50px;
}
.max-w-\\[68px\\] {
  max-width: 68px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-left {
  transform-origin: left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-100\\%\\] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-x-12 {
  --tw-skew-x: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[fadeIn_150ms_ease-out\\] {
  animation: fadeIn 150ms ease-out;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-pan-x {
  --tw-pan-x: pan-x;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.touch-pan-y {
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  -webkit-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-lg {
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}
.rounded-t-lg {
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-border {
  border-color: hsl(var(--color-border));
}
.border-border\\/30 {
  border-color: hsl(var(--color-border) / 0.3);
}
.border-border\\/50 {
  border-color: hsl(var(--color-border) / 0.5);
}
.border-border\\/60 {
  border-color: hsl(var(--color-border) / 0.6);
}
.border-current {
  border-color: currentColor;
}
.border-destructive\\/20 {
  border-color: hsl(var(--color-destructive) / 0.2);
}
.border-destructive\\/30 {
  border-color: hsl(var(--color-destructive) / 0.3);
}
.border-error {
  border-color: hsl(var(--color-error));
}
.border-error\\/20 {
  border-color: hsl(var(--color-error) / 0.2);
}
.border-error\\/30 {
  border-color: hsl(var(--color-error) / 0.3);
}
.border-foreground {
  border-color: hsl(var(--color-foreground));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/50 {
  border-color: rgb(229 231 235 / 0.5);
}
.border-gray-200\\/60 {
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-800 {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}
.border-info {
  border-color: hsl(var(--color-info));
}
.border-info\\/20 {
  border-color: hsl(var(--color-info) / 0.2);
}
.border-info\\/30 {
  border-color: hsl(var(--color-info) / 0.3);
}
.border-input {
  border-color: hsl(var(--color-input));
}
.border-muted {
  border-color: hsl(var(--color-muted));
}
.border-muted-foreground {
  border-color: hsl(var(--color-muted-foreground));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-800 {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity, 1));
}
.border-primary {
  border-color: hsl(var(--color-primary));
}
.border-primary\\/20 {
  border-color: hsl(var(--color-primary) / 0.2);
}
.border-primary\\/30 {
  border-color: hsl(var(--color-primary) / 0.3);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-success {
  border-color: hsl(var(--color-success));
}
.border-success\\/20 {
  border-color: hsl(var(--color-success) / 0.2);
}
.border-success\\/30 {
  border-color: hsl(var(--color-success) / 0.3);
}
.border-tab-bar-active\\/20 {
  border-color: hsl(var(--color-tab-bar-active) / 0.2);
}
.border-tab-bar-border {
  border-color: hsl(var(--color-tab-bar-border));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-800 {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-warning {
  border-color: hsl(var(--color-warning));
}
.border-warning\\/20 {
  border-color: hsl(var(--color-warning) / 0.2);
}
.border-warning\\/30 {
  border-color: hsl(var(--color-warning) / 0.3);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-l-accent {
  border-left-color: hsl(var(--color-accent));
}
.border-l-orange-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-l-primary {
  border-left-color: hsl(var(--color-primary));
}
.border-l-secondary {
  border-left-color: hsl(var(--color-secondary));
}
.border-opacity-20 {
  --tw-border-opacity: 0.2;
}
.border-opacity-30 {
  --tw-border-opacity: 0.3;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-background {
  background-color: hsl(var(--color-background));
}
.bg-background\\/20 {
  background-color: hsl(var(--color-background) / 0.2);
}
.bg-background\\/50 {
  background-color: hsl(var(--color-background) / 0.5);
}
.bg-background\\/80 {
  background-color: hsl(var(--color-background) / 0.8);
}
.bg-background\\/95 {
  background-color: hsl(var(--color-background) / 0.95);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-950\\/20 {
  background-color: rgb(23 37 84 / 0.2);
}
.bg-card {
  background-color: hsl(var(--color-card));
}
.bg-card\\/80 {
  background-color: hsl(var(--color-card) / 0.8);
}
.bg-card\\/90 {
  background-color: hsl(var(--color-card) / 0.9);
}
.bg-card\\/95 {
  background-color: hsl(var(--color-card) / 0.95);
}
.bg-current {
  background-color: currentColor;
}
.bg-destructive {
  background-color: hsl(var(--color-destructive));
}
.bg-destructive\\/10 {
  background-color: hsl(var(--color-destructive) / 0.1);
}
.bg-destructive\\/20 {
  background-color: hsl(var(--color-destructive) / 0.2);
}
.bg-error {
  background-color: hsl(var(--color-error));
}
.bg-error-muted {
  background-color: hsl(var(--color-error-muted));
}
.bg-error-muted\\/80 {
  background-color: hsl(var(--color-error-muted) / 0.8);
}
.bg-error-muted\\/90 {
  background-color: hsl(var(--color-error-muted) / 0.9);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-950\\/20 {
  background-color: rgb(5 46 22 / 0.2);
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-950\\/20 {
  background-color: rgb(30 27 75 / 0.2);
}
.bg-info {
  background-color: hsl(var(--color-info));
}
.bg-info-muted {
  background-color: hsl(var(--color-info-muted));
}
.bg-info-muted\\/20 {
  background-color: hsl(var(--color-info-muted) / 0.2);
}
.bg-info-muted\\/50 {
  background-color: hsl(var(--color-info-muted) / 0.5);
}
.bg-info-muted\\/80 {
  background-color: hsl(var(--color-info-muted) / 0.8);
}
.bg-info-muted\\/90 {
  background-color: hsl(var(--color-info-muted) / 0.9);
}
.bg-info\\/10 {
  background-color: hsl(var(--color-info) / 0.1);
}
.bg-info\\/20 {
  background-color: hsl(var(--color-info) / 0.2);
}
.bg-muted {
  background-color: hsl(var(--color-muted));
}
.bg-muted\\/10 {
  background-color: hsl(var(--color-muted) / 0.1);
}
.bg-muted\\/20 {
  background-color: hsl(var(--color-muted) / 0.2);
}
.bg-muted\\/30 {
  background-color: hsl(var(--color-muted) / 0.3);
}
.bg-muted\\/50 {
  background-color: hsl(var(--color-muted) / 0.5);
}
.bg-muted\\/90 {
  background-color: hsl(var(--color-muted) / 0.9);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-950\\/20 {
  background-color: rgb(67 20 7 / 0.2);
}
.bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-950\\/20 {
  background-color: rgb(80 7 36 / 0.2);
}
.bg-popover {
  background-color: hsl(var(--color-popover));
}
.bg-primary {
  background-color: hsl(var(--color-primary));
}
.bg-primary-foreground {
  background-color: hsl(var(--color-primary-foreground));
}
.bg-primary-muted {
  background-color: hsl(var(--color-primary-muted));
}
.bg-primary\\/10 {
  background-color: hsl(var(--color-primary) / 0.1);
}
.bg-primary\\/5 {
  background-color: hsl(var(--color-primary) / 0.05);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-950\\/20 {
  background-color: rgb(59 7 100 / 0.2);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  background-color: hsl(var(--color-secondary));
}
.bg-success {
  background-color: hsl(var(--color-success));
}
.bg-success-muted {
  background-color: hsl(var(--color-success-muted));
}
.bg-success-muted\\/50 {
  background-color: hsl(var(--color-success-muted) / 0.5);
}
.bg-success-muted\\/80 {
  background-color: hsl(var(--color-success-muted) / 0.8);
}
.bg-success-muted\\/90 {
  background-color: hsl(var(--color-success-muted) / 0.9);
}
.bg-success\\/10 {
  background-color: hsl(var(--color-success) / 0.1);
}
.bg-success\\/20 {
  background-color: hsl(var(--color-success) / 0.2);
}
.bg-surface {
  background-color: hsl(var(--color-surface));
}
.bg-tab-bar-active {
  background-color: hsl(var(--color-tab-bar-active));
}
.bg-tab-bar-active\\/10 {
  background-color: hsl(var(--color-tab-bar-active) / 0.1);
}
.bg-tab-bar\\/95 {
  background-color: hsl(var(--color-tab-bar) / 0.95);
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-950\\/20 {
  background-color: rgb(4 47 46 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  background-color: hsl(var(--color-warning));
}
.bg-warning-muted {
  background-color: hsl(var(--color-warning-muted));
}
.bg-warning-muted\\/50 {
  background-color: hsl(var(--color-warning-muted) / 0.5);
}
.bg-warning-muted\\/80 {
  background-color: hsl(var(--color-warning-muted) / 0.8);
}
.bg-warning-muted\\/90 {
  background-color: hsl(var(--color-warning-muted) / 0.9);
}
.bg-warning\\/10 {
  background-color: hsl(var(--color-warning) / 0.1);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-950\\/20 {
  background-color: rgb(66 32 6 / 0.2);
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-95 {
  --tw-bg-opacity: 0.95;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-background {
  --tw-gradient-from: hsl(var(--color-background)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--color-background) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-background\\/90 {
  --tw-gradient-from: hsl(var(--color-background) / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--color-background) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100 {
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400\\/10 {
  --tw-gradient-from: rgb(96 165 250 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50 {
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/80 {
  --tw-gradient-from: rgb(239 246 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/10 {
  --tw-gradient-from: rgb(59 130 246 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/5 {
  --tw-gradient-from: rgb(59 130 246 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-800 {
  --tw-gradient-from: #1e40af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-900 {
  --tw-gradient-from: #1e3a8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400\\/10 {
  --tw-gradient-from: rgb(52 211 153 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50 {
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500\\/5 {
  --tw-gradient-from: rgb(16 185 129 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50 {
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/10 {
  --tw-gradient-from: rgb(34 197 94 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/5 {
  --tw-gradient-from: rgb(34 197 94 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-700 {
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500\\/5 {
  --tw-gradient-from: rgb(99 102 241 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400\\/10 {
  --tw-gradient-from: rgb(251 146 60 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50 {
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500\\/5 {
  --tw-gradient-from: rgb(249 115 22 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-800 {
  --tw-gradient-from: #9a3412 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(154 52 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #db2777 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: hsl(var(--color-primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--color-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/5 {
  --tw-gradient-from: hsl(var(--color-primary) / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--color-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400 {
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50 {
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500\\/10 {
  --tw-gradient-from: rgb(168 85 247 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-700 {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500\\/5 {
  --tw-gradient-from: rgb(239 68 68 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-700 {
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-100 {
  --tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500 {
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #0d9488 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(13 148 136 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500 {
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600 {
  --tw-gradient-from: #ca8a04 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(202 138 4 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-background {
  --tw-gradient-to: hsl(var(--color-background) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--color-background)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-50 {
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #eff6ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-600 {
  --tw-gradient-to: rgb(37 99 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2563eb var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-800 {
  --tw-gradient-to: rgb(30 64 175 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e40af var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-800 {
  --tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1f2937 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-50 {
  --tw-gradient-to: rgb(238 242 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #eef2ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/5 {
  --tw-gradient-to: hsl(var(--color-primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--color-primary) / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50 {
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #faf5ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500 {
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600 {
  --tw-gradient-to: rgb(147 51 234 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9333ea var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-600 {
  --tw-gradient-to: rgb(124 58 237 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7c3aed var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/20 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/80 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-500\\/10 {
  --tw-gradient-to: rgb(245 158 11 / 0.1) var(--tw-gradient-to-position);
}
.to-amber-600 {
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-blue-50 {
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-700 {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-50 {
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-500\\/10 {
  --tw-gradient-to: rgb(16 185 129 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-fuchsia-600 {
  --tw-gradient-to: #c026d3 var(--tw-gradient-to-position);
}
.to-gray-100 {
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-gray-900 {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}
.to-green-50 {
  --tw-gradient-to: #f0fdf4 var(--tw-gradient-to-position);
}
.to-green-500 {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-green-500\\/10 {
  --tw-gradient-to: rgb(34 197 94 / 0.1) var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-green-600\\/10 {
  --tw-gradient-to: rgb(22 163 74 / 0.1) var(--tw-gradient-to-position);
}
.to-indigo-100 {
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-50 {
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/80 {
  --tw-gradient-to: rgb(238 242 255 / 0.8) var(--tw-gradient-to-position);
}
.to-indigo-500 {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-500\\/10 {
  --tw-gradient-to: rgb(99 102 241 / 0.1) var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-600\\/10 {
  --tw-gradient-to: rgb(79 70 229 / 0.1) var(--tw-gradient-to-position);
}
.to-muted\\/10 {
  --tw-gradient-to: hsl(var(--color-muted) / 0.1) var(--tw-gradient-to-position);
}
.to-muted\\/20 {
  --tw-gradient-to: hsl(var(--color-muted) / 0.2) var(--tw-gradient-to-position);
}
.to-muted\\/30 {
  --tw-gradient-to: hsl(var(--color-muted) / 0.3) var(--tw-gradient-to-position);
}
.to-orange-50 {
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-400 {
  --tw-gradient-to: #f472b6 var(--tw-gradient-to-position);
}
.to-pink-50 {
  --tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-500\\/10 {
  --tw-gradient-to: rgb(236 72 153 / 0.1) var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-purple-50 {
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-500\\/10 {
  --tw-gradient-to: rgb(168 85 247 / 0.1) var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-red-50 {
  --tw-gradient-to: #fef2f2 var(--tw-gradient-to-position);
}
.to-red-500 {
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-500\\/10 {
  --tw-gradient-to: rgb(239 68 68 / 0.1) var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-red-600\\/10 {
  --tw-gradient-to: rgb(220 38 38 / 0.1) var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-600 {
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}
.to-secondary\\/5 {
  --tw-gradient-to: hsl(var(--color-secondary) / 0.05) var(--tw-gradient-to-position);
}
.to-slate-100 {
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-slate-50 {
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-teal-50 {
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-500\\/10 {
  --tw-gradient-to: rgb(20 184 166 / 0.1) var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-500\\/10 {
  --tw-gradient-to: rgb(139 92 246 / 0.1) var(--tw-gradient-to-position);
}
.to-violet-600 {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-yellow-600 {
  --tw-gradient-to: #ca8a04 var(--tw-gradient-to-position);
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.fill-current {
  fill: currentColor;
}
.fill-warning {
  fill: hsl(var(--color-warning));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-4 {
  line-height: 1rem;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-accent {
  color: hsl(var(--color-accent));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  color: hsl(var(--color-card-foreground));
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: hsl(var(--color-destructive));
}
.text-destructive-foreground {
  color: hsl(var(--color-destructive-foreground));
}
.text-error {
  color: hsl(var(--color-error));
}
.text-error-foreground {
  color: hsl(var(--color-error-foreground));
}
.text-foreground {
  color: hsl(var(--color-foreground));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-info {
  color: hsl(var(--color-info));
}
.text-info-foreground {
  color: hsl(var(--color-info-foreground));
}
.text-muted-foreground {
  color: hsl(var(--color-muted-foreground));
}
.text-muted-foreground\\/50 {
  color: hsl(var(--color-muted-foreground) / 0.5);
}
.text-muted-foreground\\/60 {
  color: hsl(var(--color-muted-foreground) / 0.6);
}
.text-muted-foreground\\/70 {
  color: hsl(var(--color-muted-foreground) / 0.7);
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-300 {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-popover-foreground {
  color: hsl(var(--color-popover-foreground));
}
.text-primary {
  color: hsl(var(--color-primary));
}
.text-primary-foreground {
  color: hsl(var(--color-primary-foreground));
}
.text-primary-foreground\\/80 {
  color: hsl(var(--color-primary-foreground) / 0.8);
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-secondary {
  color: hsl(var(--color-secondary));
}
.text-secondary-foreground {
  color: hsl(var(--color-secondary-foreground));
}
.text-success {
  color: hsl(var(--color-success));
}
.text-success-foreground {
  color: hsl(var(--color-success-foreground));
}
.text-surface-foreground {
  color: hsl(var(--color-surface-foreground));
}
.text-tab-bar-active {
  color: hsl(var(--color-tab-bar-active));
}
.text-tab-bar-foreground\\/70 {
  color: hsl(var(--color-tab-bar-foreground) / 0.7);
}
.text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-warning {
  color: hsl(var(--color-warning));
}
.text-warning-foreground {
  color: hsl(var(--color-warning-foreground));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.placeholder-muted-foreground::placeholder {
  color: hsl(var(--color-muted-foreground));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-90 {
  opacity: 0.9;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-primary\\/10 {
  --tw-shadow-color: hsl(var(--color-primary) / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/25 {
  --tw-shadow-color: hsl(var(--color-primary) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-amber-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.ring-primary\\/50 {
  --tw-ring-color: hsl(var(--color-primary) / 0.5);
}
.ring-purple-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.ring-red-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--color-background));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-4 {
  --tw-enter-translate-y: 1rem;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-150 {
  animation-duration: 150ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.duration-700 {
  animation-duration: 700ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.paused {
  animation-play-state: paused;
}
.title-truncate-short {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
  }
.title-truncate-responsive {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 120px;
  }
@media (min-width: 640px) {
    .title-truncate-responsive {
      max-width: 200px;
    }
  }
@media (min-width: 1024px) {
    .title-truncate-responsive {
      max-width: 300px;
    }
  }
.\\[backface-visibility\\:hidden\\] {
  backface-visibility: hidden;
}
.\\[transform\\:rotateY\\(180deg\\)\\] {
  transform: rotateY(180deg);
}

/* Custom animations and effects */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

@keyframes slideInFromRight {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes gentle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

@keyframes pulse-glow {
  0%, 100% { 
    box-shadow: 0 0 20px hsl(var(--color-primary) / 0.3);
    transform: scale(1);
  }
  50% { 
    box-shadow: 0 0 30px hsl(var(--color-primary) / 0.5);
    transform: scale(1.02);
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes scale-in {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

@keyframes wiggle {
  0%, 7%, 14%, 21% { transform: rotate(4deg); }
  3.5%, 10.5%, 17.5% { transform: rotate(-4deg); }
  25% { transform: rotate(0deg); }
}

@keyframes heart-beat {
  0%, 40%, 80%, 100% { transform: scale(1); }
  20%, 60% { transform: scale(1.15); }
}

@keyframes glow {
  0%, 100% { filter: drop-shadow(0 0 5px hsl(var(--color-primary) / 0.5)); }
  50% { filter: drop-shadow(0 0 20px hsl(var(--color-primary) / 0.8)); }
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}

.animate-slide-in {
  animation: slideIn 0.3s ease-out;
}

.animate-slide-in-right {
  animation: slideInFromRight 0.4s ease-out;
}

.animate-slide-up {
  animation: slideUp 0.4s ease-out;
}

.animate-gentle-bounce {
  animation: gentle-bounce 0.6s ease-in-out;
}

.animate-pulse-glow {
  animation: pulse-glow 2s ease-in-out infinite;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-spin-slow {
  animation: spin-slow 3s linear infinite;
}

.animate-scale-in {
  animation: scale-in 0.3s ease-out;
}

.animate-wiggle {
  animation: wiggle 1s ease-in-out;
}

.animate-heart-beat {
  animation: heart-beat 1.5s ease-in-out infinite;
}

.animate-glow {
  animation: glow 2s ease-in-out infinite;
}

/* Interactive card effects */
.interactive-card {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}
.interactive-card:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.interactive-card {
  position: relative;
  overflow: hidden;
}

.interactive-card:hover {
  animation: gentle-bounce 0.6s ease-in-out;
}

.interactive-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    hsl(var(--color-foreground) / 0.1),
    transparent
  );
  transition: left 0.5s;
}

.interactive-card:hover::before {
  left: 100%;
}

/* Exam board themed cards */
.board-card-cambridge {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #1e3a8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}

.board-card-sat {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #3730a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 48 163 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}

.board-card-edexcel {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}

.board-card-ap {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}

.board-card-ib {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #9a3412 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(154 52 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}

.board-card-k12 {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}

/* Enhanced hover effects */
.hover-lift {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.hover-lift:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover-glow {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.hover-glow:hover {
  filter: drop-shadow(0 10px 20px hsl(var(--color-primary) / 0.3));
}

.hover-scale {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.hover-scale:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* Loading skeleton animations */
.skeleton {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 231 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: rgb(209 213 219 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #d1d5db var(--tw-gradient-via-position), var(--tw-gradient-to);
  --tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);
}
.skeleton:is(.dark *) {
  --tw-gradient-from: #374151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: rgb(75 85 99 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4b5563 var(--tw-gradient-via-position), var(--tw-gradient-to);
  --tw-gradient-to: #374151 var(--tw-gradient-to-position);
}
.skeleton {
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Progress bar animations */
.progress-bar {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
  animation: progress-fill 1s ease-out;
}

@keyframes progress-fill {
  from { width: 0%; }
}

/* Badge animations */
.badge-pulse {
  animation: badge-pulse 2s infinite;
}

@keyframes badge-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Button hover effects */
.btn-primary {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.btn-primary:hover {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.btn-primary {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}
.btn-primary:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-success {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}

.btn-success:hover {
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}

.btn-success {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.btn-success:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-warning {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}

.btn-warning:hover {
  --tw-gradient-from: #ca8a04 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(202 138 4 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}

.btn-warning {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.btn-warning:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-danger {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}

.btn-danger:hover {
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.btn-danger {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  animation-duration: 300ms;
}

.btn-danger:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Shimmer effect for loading states */
.shimmer {
  position: relative;
  overflow: hidden;
}

.shimmer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

/* Gradient text utility */
.gradient-text {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: hsl(var(--color-primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--color-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
  -webkit-background-clip: text;
          background-clip: text;
  color: transparent;
}

/* Glassmorphism effect */
.glass {
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.2);
  background-color: rgb(255 255 255 / 0.1);
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.glass:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
  background-color: rgb(0 0 0 / 0.1);
}

/* Custom scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background-color: hsl(var(--color-muted));
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 9999px;
  background-color: hsl(var(--color-border));
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: hsl(var(--color-muted-foreground));
}

/* Line clamp utilities */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Document Analysis Enhanced Styles */
.doc-analysis-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.dark .doc-analysis-container {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
}

.doc-analysis-header {
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: sticky;
  top: 0;
  z-index: 100;
}

.dark .doc-analysis-header {
  background: rgba(34, 34, 34, 0.95);
  border-bottom: 1px solid hsl(var(--color-foreground) / 0.1);
}

/* Tab Navigation Animations */
.doc-tab-nav {
  background: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 8px;
  box-shadow: 0 8px 32px hsl(var(--color-background) / 0.1);
}

.dark .doc-tab-nav {
  background: rgba(34, 34, 34, 0.8);
}

.doc-tab-button {
  position: relative;
  padding: 12px 24px;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.doc-tab-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: var(--doc-primary-gradient);
  transition: left 0.4s ease;
  z-index: -1;
}

.doc-tab-button:hover::before {
  left: 0;
}

.doc-tab-button.active {
  background: var(--doc-primary-gradient);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.doc-tab-button:hover {
  transform: translateY(-2px);
  color: white;
}

/* Interactive Cards */
.doc-interactive-card {
  background: rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.dark .doc-interactive-card {
  background: rgba(42, 42, 42, 0.9);
  border: 1px solid hsl(var(--color-foreground) / 0.1);
}

.doc-interactive-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--doc-primary-gradient);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.doc-interactive-card:hover::before {
  transform: scaleX(1);
}

.doc-interactive-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

/* Enhanced Chat Interface */
.doc-chat-container {
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.dark .doc-chat-container {
  background: rgba(42, 42, 42, 0.95);
  border: 1px solid hsl(var(--color-foreground) / 0.1);
}

.doc-chat-message {
  padding: 16px 20px;
  margin: 8px 0;
  border-radius: 18px;
  max-width: 85%;
  position: relative;
  animation: messageSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.doc-chat-message.user {
  background: var(--doc-primary-gradient);
  color: white;
  align-self: flex-end;
  margin-left: auto;
}

.doc-chat-message.ai {
  background: rgba(241, 245, 249, 0.8);
  color: #334155;
  align-self: flex-start;
  border: 1px solid rgba(226, 232, 240, 0.5);
}

.dark .doc-chat-message.ai {
  background: rgba(51, 51, 51, 0.8);
  color: #e2e8f0;
  border: 1px solid hsl(var(--color-foreground) / 0.1);
}

.doc-chat-input {
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(226, 232, 240, 0.5);
  border-radius: 16px;
  padding: 16px 20px;
  transition: all 0.3s ease;
  resize: none;
}

.dark .doc-chat-input {
  background: rgba(51, 51, 51, 0.9);
  border: 2px solid hsl(var(--color-foreground) / 0.1);
  color: white;
}

.doc-chat-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  transform: scale(1.01);
}

/* Game Elements */
.doc-game-card {
  background: var(--doc-secondary-gradient);
  color: white;
  border-radius: 20px;
  padding: 24px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.doc-game-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, hsl(var(--color-foreground) / 0.1) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.doc-game-card:hover::before {
  opacity: 1;
}

.doc-game-card:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.doc-drag-item {
  background: rgba(255, 255, 255, 0.9);
  border: 2px dashed rgba(102, 126, 234, 0.3);
  border-radius: 12px;
  padding: 16px;
  margin: 8px;
  cursor: grab;
  transition: all 0.3s ease;
}

.doc-drag-item:hover {
  border-color: #667eea;
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);
}

.doc-drag-item.dragging {
  opacity: 0.5;
  transform: rotate(5deg) scale(1.1);
  cursor: grabbing;
}

.doc-drop-zone {
  background: rgba(241, 245, 249, 0.6);
  border: 2px dashed rgba(148, 163, 184, 0.5);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;
}

.doc-drop-zone.active {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.1);
  transform: scale(1.02);
}

/* Podcast Player Styling */
.doc-podcast-player {
  background: var(--doc-success-gradient);
  border-radius: 24px;
  padding: 24px;
  color: white;
  position: relative;
  overflow: hidden;
}

.doc-podcast-player::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat;
  opacity: 0.3;
}

.doc-podcast-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}

.doc-podcast-progress {
  flex: 1;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.doc-podcast-progress-bar {
  height: 100%;
  background: white;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.doc-podcast-button {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-podcast-button:hover {
  background: hsl(var(--color-foreground) / 0.3);
  transform: scale(1.1);
}

/* Mind Map Styling */
.doc-mindmap-container {
  background: radial-gradient(circle at center, rgba(102, 126, 234, 0.1) 0%, transparent 70%);
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

.doc-mindmap-node {
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(102, 126, 234, 0.3);
  border-radius: 16px;
  padding: 16px 20px;
  position: absolute;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.dark .doc-mindmap-node {
  background: rgba(51, 51, 51, 0.9);
  border-color: rgba(102, 126, 234, 0.5);
}

.doc-mindmap-node:hover {
  transform: scale(1.1);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.3);
  z-index: 10;
}

.doc-mindmap-connection {
  stroke: rgba(102, 126, 234, 0.6);
  stroke-width: 2;
  fill: none;
  stroke-dasharray: 5,5;
  animation: connectionPulse 2s ease-in-out infinite;
}

@keyframes connectionPulse {
  0%, 100% { stroke-opacity: 0.6; }
  50% { stroke-opacity: 1; }
}

/* Loading Animations */
.doc-loading-skeleton {
  background: linear-gradient(90deg, rgba(241, 245, 249, 0.8) 25%, rgba(226, 232, 240, 0.8) 50%, rgba(241, 245, 249, 0.8) 75%);
  background-size: 200% 100%;
  animation: skeletonLoading 1.5s ease-in-out infinite;
  border-radius: 8px;
}

.dark .doc-loading-skeleton {
  background: linear-gradient(90deg, rgba(51, 51, 51, 0.8) 25%, rgba(68, 68, 68, 0.8) 50%, rgba(51, 51, 51, 0.8) 75%);
  background-size: 200% 100%;
}

@keyframes skeletonLoading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.doc-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(102, 126, 234, 0.2);
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Success and Error States */
.doc-success-message {
  background: var(--doc-success-gradient);
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  animation: successSlideIn 0.5s ease-out;
}

@keyframes successSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.doc-error-message {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  animation: errorShake 0.5s ease-out;
}

@keyframes errorShake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

/* Responsive Enhancements */
@media (max-width: 768px) {
  .doc-tab-nav {
    padding: 4px;
    margin: 0 16px;
  }
  
  .doc-tab-button {
    padding: 8px 16px;
    font-size: 14px;
  }
  
  .doc-chat-container {
    min-height: 400px;
    margin: 16px;
  }
  
  .doc-interactive-card {
    margin: 8px;
  }
  
  .doc-game-card {
    padding: 16px;
  }
  
  .doc-mindmap-node {
    padding: 12px 16px;
    font-size: 14px;
  }
}

/* Title truncation utilities */

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--color-muted-foreground));
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-2:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-blue-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-border:hover {
  border-color: hsl(var(--color-border));
}

.hover\\:border-destructive:hover {
  border-color: hsl(var(--color-destructive));
}

.hover\\:border-error\\/30:hover {
  border-color: hsl(var(--color-error) / 0.3);
}

.hover\\:border-foreground:hover {
  border-color: hsl(var(--color-foreground));
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-info:hover {
  border-color: hsl(var(--color-info));
}

.hover\\:border-info\\/40:hover {
  border-color: hsl(var(--color-info) / 0.4);
}

.hover\\:border-muted-foreground\\/50:hover {
  border-color: hsl(var(--color-muted-foreground) / 0.5);
}

.hover\\:border-primary:hover {
  border-color: hsl(var(--color-primary));
}

.hover\\:border-primary\\/40:hover {
  border-color: hsl(var(--color-primary) / 0.4);
}

.hover\\:border-primary\\/50:hover {
  border-color: hsl(var(--color-primary) / 0.5);
}

.hover\\:border-purple-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-secondary:hover {
  border-color: hsl(var(--color-secondary));
}

.hover\\:border-success\\/30:hover {
  border-color: hsl(var(--color-success) / 0.3);
}

.hover\\:border-warning\\/30:hover {
  border-color: hsl(var(--color-warning) / 0.3);
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--color-accent));
}

.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-background\\/90:hover {
  background-color: hsl(var(--color-background) / 0.9);
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive\\/10:hover {
  background-color: hsl(var(--color-destructive) / 0.1);
}

.hover\\:bg-destructive\\/20:hover {
  background-color: hsl(var(--color-destructive) / 0.2);
}

.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--color-destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--color-destructive) / 0.9);
}

.hover\\:bg-error:hover {
  background-color: hsl(var(--color-error));
}

.hover\\:bg-error-hover:hover {
  background-color: hsl(var(--color-error-hover));
}

.hover\\:bg-error-muted:hover {
  background-color: hsl(var(--color-error-muted));
}

.hover\\:bg-error\\/10:hover {
  background-color: hsl(var(--color-error) / 0.1);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-info:hover {
  background-color: hsl(var(--color-info));
}

.hover\\:bg-info-hover:hover {
  background-color: hsl(var(--color-info-hover));
}

.hover\\:bg-info-muted:hover {
  background-color: hsl(var(--color-info-muted));
}

.hover\\:bg-info\\/10:hover {
  background-color: hsl(var(--color-info) / 0.1);
}

.hover\\:bg-info\\/20:hover {
  background-color: hsl(var(--color-info) / 0.2);
}

.hover\\:bg-muted:hover {
  background-color: hsl(var(--color-muted));
}

.hover\\:bg-muted\\/30:hover {
  background-color: hsl(var(--color-muted) / 0.3);
}

.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--color-muted) / 0.5);
}

.hover\\:bg-primary:hover {
  background-color: hsl(var(--color-primary));
}

.hover\\:bg-primary-hover:hover {
  background-color: hsl(var(--color-primary-hover));
}

.hover\\:bg-primary-muted:hover {
  background-color: hsl(var(--color-primary-muted));
}

.hover\\:bg-primary\\/10:hover {
  background-color: hsl(var(--color-primary) / 0.1);
}

.hover\\:bg-primary\\/20:hover {
  background-color: hsl(var(--color-primary) / 0.2);
}

.hover\\:bg-primary\\/5:hover {
  background-color: hsl(var(--color-primary) / 0.05);
}

.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--color-primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--color-primary) / 0.9);
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary-hover:hover {
  background-color: hsl(var(--color-secondary-hover));
}

.hover\\:bg-secondary\\/5:hover {
  background-color: hsl(var(--color-secondary) / 0.05);
}

.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--color-secondary) / 0.8);
}

.hover\\:bg-success:hover {
  background-color: hsl(var(--color-success));
}

.hover\\:bg-success-hover:hover {
  background-color: hsl(var(--color-success-hover));
}

.hover\\:bg-success-muted:hover {
  background-color: hsl(var(--color-success-muted));
}

.hover\\:bg-success\\/10:hover {
  background-color: hsl(var(--color-success) / 0.1);
}

.hover\\:bg-success\\/90:hover {
  background-color: hsl(var(--color-success) / 0.9);
}

.hover\\:bg-tab-bar-active\\/5:hover {
  background-color: hsl(var(--color-tab-bar-active) / 0.05);
}

.hover\\:bg-warning:hover {
  background-color: hsl(var(--color-warning));
}

.hover\\:bg-warning-hover:hover {
  background-color: hsl(var(--color-warning-hover));
}

.hover\\:bg-warning-muted:hover {
  background-color: hsl(var(--color-warning-muted));
}

.hover\\:bg-warning\\/10:hover {
  background-color: hsl(var(--color-warning) / 0.1);
}

.hover\\:bg-warning\\/20:hover {
  background-color: hsl(var(--color-warning) / 0.2);
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/70:hover {
  background-color: rgb(255 255 255 / 0.7);
}

.hover\\:bg-opacity-30:hover {
  --tw-bg-opacity: 0.3;
}

.hover\\:from-blue-600:hover {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-700:hover {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-emerald-600:hover {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-600:hover {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-orange-600:hover {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-600:hover {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:via-blue-700:hover {
  --tw-gradient-to: rgb(29 78 216 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1d4ed8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.hover\\:to-blue-700:hover {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-blue-800:hover {
  --tw-gradient-to: #1e40af var(--tw-gradient-to-position);
}

.hover\\:to-emerald-600:hover {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}

.hover\\:to-green-700:hover {
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover {
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.hover\\:to-pink-600:hover {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.hover\\:to-purple-600:hover {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.hover\\:to-purple-700:hover {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:to-red-700:hover {
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}

.hover\\:to-teal-600:hover {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--color-accent-foreground));
}

.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-destructive:hover {
  color: hsl(var(--color-destructive));
}

.hover\\:text-error:hover {
  color: hsl(var(--color-error));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--color-foreground));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.hover\\:text-muted-foreground:hover {
  color: hsl(var(--color-muted-foreground));
}

.hover\\:text-primary:hover {
  color: hsl(var(--color-primary));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-tab-bar-foreground:hover {
  color: hsl(var(--color-tab-bar-foreground));
}

.hover\\:text-warning:hover {
  color: hsl(var(--color-warning));
}

.hover\\:text-yellow-500:hover {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-600:hover {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-error:focus {
  border-color: hsl(var(--color-error));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-info:focus {
  border-color: hsl(var(--color-info));
}

.focus\\:border-ring:focus {
  border-color: hsl(var(--color-ring));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.focus\\:ring-blue-500\\/30:focus {
  --tw-ring-color: rgb(59 130 246 / 0.3);
}

.focus\\:ring-destructive\\/20:focus {
  --tw-ring-color: hsl(var(--color-destructive) / 0.2);
}

.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary:focus {
  --tw-ring-color: hsl(var(--color-primary));
}

.focus\\:ring-primary\\/20:focus {
  --tw-ring-color: hsl(var(--color-primary) / 0.2);
}

.focus\\:ring-purple-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500\\/20:focus {
  --tw-ring-color: rgb(239 68 68 / 0.2);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--color-ring));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--color-ring));
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-gray-400:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-muted:disabled {
  background-color: hsl(var(--color-muted));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:opacity-disabled:disabled {
  opacity: var(--opacity-disabled);
}

.group:focus-within .group-focus-within\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:focus-within .group-focus-within\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:-translate-x-0\\.5 {
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-2 {
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-\\[100\\%\\] {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.group:hover .group-hover\\:animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.group:hover .group-hover\\:border-info\\/40 {
  border-color: hsl(var(--color-info) / 0.4);
}

.group:hover .group-hover\\:border-primary\\/40 {
  border-color: hsl(var(--color-primary) / 0.4);
}

.group:hover .group-hover\\:bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}

.group:hover .group-hover\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-info-muted {
  background-color: hsl(var(--color-info-muted));
}

.group:hover .group-hover\\:bg-primary-muted {
  background-color: hsl(var(--color-primary-muted));
}

.group:hover .group-hover\\:bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-info {
  color: hsl(var(--color-info));
}

.group:hover .group-hover\\:text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-10 {
  opacity: 0.1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

@supports ((-webkit-backdrop-filter: var(--tw)) or (backdrop-filter: var(--tw))) {

  .supports-\\[backdrop-filter\\]\\:bg-background\\/80 {
    background-color: hsl(var(--color-background) / 0.8);
  }
}

.dark\\:border-amber-500\\/20:is(.dark *) {
  border-color: rgb(245 158 11 / 0.2);
}

.dark\\:border-amber-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:border-border:is(.dark *) {
  border-color: hsl(var(--color-border));
}

.dark\\:border-error:is(.dark *) {
  border-color: hsl(var(--color-error));
}

.dark\\:border-error\\/40:is(.dark *) {
  border-color: hsl(var(--color-error) / 0.4);
}

.dark\\:border-gray-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700\\/50:is(.dark *) {
  border-color: rgb(55 65 81 / 0.5);
}

.dark\\:border-gray-700\\/60:is(.dark *) {
  border-color: rgb(55 65 81 / 0.6);
}

.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.dark\\:border-info:is(.dark *) {
  border-color: hsl(var(--color-info));
}

.dark\\:border-orange-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity, 1));
}

.dark\\:border-primary:is(.dark *) {
  border-color: hsl(var(--color-primary));
}

.dark\\:border-primary\\/40:is(.dark *) {
  border-color: hsl(var(--color-primary) / 0.4);
}

.dark\\:border-purple-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}

.dark\\:border-success:is(.dark *) {
  border-color: hsl(var(--color-success));
}

.dark\\:border-success\\/40:is(.dark *) {
  border-color: hsl(var(--color-success) / 0.4);
}

.dark\\:border-warning:is(.dark *) {
  border-color: hsl(var(--color-warning));
}

.dark\\:border-yellow-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity, 1));
}

.dark\\:bg-amber-500\\/10:is(.dark *) {
  background-color: rgb(245 158 11 / 0.1);
}

.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:bg-amber-900\\/40:is(.dark *) {
  background-color: rgb(120 53 15 / 0.4);
}

.dark\\:bg-blue-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-blue-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-950\\/20:is(.dark *) {
  background-color: rgb(23 37 84 / 0.2);
}

.dark\\:bg-blue-950\\/50:is(.dark *) {
  background-color: rgb(23 37 84 / 0.5);
}

.dark\\:bg-destructive\\/20:is(.dark *) {
  background-color: hsl(var(--color-destructive) / 0.2);
}

.dark\\:bg-destructive\\/30:is(.dark *) {
  background-color: hsl(var(--color-destructive) / 0.3);
}

.dark\\:bg-error:is(.dark *) {
  background-color: hsl(var(--color-error));
}

.dark\\:bg-error-muted:is(.dark *) {
  background-color: hsl(var(--color-error-muted));
}

.dark\\:bg-error-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-error-muted) / 0.2);
}

.dark\\:bg-error-muted\\/30:is(.dark *) {
  background-color: hsl(var(--color-error-muted) / 0.3);
}

.dark\\:bg-error-muted\\/40:is(.dark *) {
  background-color: hsl(var(--color-error-muted) / 0.4);
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800\\/50:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-800\\/60:is(.dark *) {
  background-color: rgb(31 41 55 / 0.6);
}

.dark\\:bg-gray-800\\/70:is(.dark *) {
  background-color: rgb(31 41 55 / 0.7);
}

.dark\\:bg-gray-800\\/80:is(.dark *) {
  background-color: rgb(31 41 55 / 0.8);
}

.dark\\:bg-gray-800\\/90:is(.dark *) {
  background-color: rgb(31 41 55 / 0.9);
}

.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(17 24 39 / 0.4);
}

.dark\\:bg-gray-900\\/50:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:bg-gray-900\\/95:is(.dark *) {
  background-color: rgb(17 24 39 / 0.95);
}

.dark\\:bg-green-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-green-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-950\\/50:is(.dark *) {
  background-color: rgb(5 46 22 / 0.5);
}

.dark\\:bg-indigo-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-900\\/20:is(.dark *) {
  background-color: rgb(49 46 129 / 0.2);
}

.dark\\:bg-indigo-900\\/30:is(.dark *) {
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:bg-info:is(.dark *) {
  background-color: hsl(var(--color-info));
}

.dark\\:bg-info-muted:is(.dark *) {
  background-color: hsl(var(--color-info-muted));
}

.dark\\:bg-info-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-info-muted) / 0.2);
}

.dark\\:bg-info-muted\\/30:is(.dark *) {
  background-color: hsl(var(--color-info-muted) / 0.3);
}

.dark\\:bg-info-muted\\/50:is(.dark *) {
  background-color: hsl(var(--color-info-muted) / 0.5);
}

.dark\\:bg-info\\/20:is(.dark *) {
  background-color: hsl(var(--color-info) / 0.2);
}

.dark\\:bg-info\\/30:is(.dark *) {
  background-color: hsl(var(--color-info) / 0.3);
}

.dark\\:bg-muted:is(.dark *) {
  background-color: hsl(var(--color-muted));
}

.dark\\:bg-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-muted) / 0.2);
}

.dark\\:bg-muted\\/50:is(.dark *) {
  background-color: hsl(var(--color-muted) / 0.5);
}

.dark\\:bg-muted\\/90:is(.dark *) {
  background-color: hsl(var(--color-muted) / 0.9);
}

.dark\\:bg-orange-900\\/20:is(.dark *) {
  background-color: rgb(124 45 18 / 0.2);
}

.dark\\:bg-orange-950\\/20:is(.dark *) {
  background-color: rgb(67 20 7 / 0.2);
}

.dark\\:bg-orange-950\\/50:is(.dark *) {
  background-color: rgb(67 20 7 / 0.5);
}

.dark\\:bg-pink-900\\/30:is(.dark *) {
  background-color: rgb(131 24 67 / 0.3);
}

.dark\\:bg-primary-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-primary-muted) / 0.2);
}

.dark\\:bg-primary-muted\\/30:is(.dark *) {
  background-color: hsl(var(--color-primary-muted) / 0.3);
}

.dark\\:bg-primary-muted\\/50:is(.dark *) {
  background-color: hsl(var(--color-primary-muted) / 0.5);
}

.dark\\:bg-primary\\/20:is(.dark *) {
  background-color: hsl(var(--color-primary) / 0.2);
}

.dark\\:bg-purple-500\\/10:is(.dark *) {
  background-color: rgb(168 85 247 / 0.1);
}

.dark\\:bg-purple-900\\/20:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}

.dark\\:bg-purple-900\\/50:is(.dark *) {
  background-color: rgb(88 28 135 / 0.5);
}

.dark\\:bg-purple-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-950\\/50:is(.dark *) {
  background-color: rgb(59 7 100 / 0.5);
}

.dark\\:bg-red-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900\\/10:is(.dark *) {
  background-color: rgb(127 29 29 / 0.1);
}

.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-success:is(.dark *) {
  background-color: hsl(var(--color-success));
}

.dark\\:bg-success-muted:is(.dark *) {
  background-color: hsl(var(--color-success-muted));
}

.dark\\:bg-success-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-success-muted) / 0.2);
}

.dark\\:bg-success-muted\\/30:is(.dark *) {
  background-color: hsl(var(--color-success-muted) / 0.3);
}

.dark\\:bg-success-muted\\/40:is(.dark *) {
  background-color: hsl(var(--color-success-muted) / 0.4);
}

.dark\\:bg-success\\/20:is(.dark *) {
  background-color: hsl(var(--color-success) / 0.2);
}

.dark\\:bg-success\\/30:is(.dark *) {
  background-color: hsl(var(--color-success) / 0.3);
}

.dark\\:bg-teal-900\\/30:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.dark\\:bg-warning:is(.dark *) {
  background-color: hsl(var(--color-warning));
}

.dark\\:bg-warning-muted\\/20:is(.dark *) {
  background-color: hsl(var(--color-warning-muted) / 0.2);
}

.dark\\:bg-warning-muted\\/30:is(.dark *) {
  background-color: hsl(var(--color-warning-muted) / 0.3);
}

.dark\\:bg-warning\\/20:is(.dark *) {
  background-color: hsl(var(--color-warning) / 0.2);
}

.dark\\:bg-white\\/5:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-yellow-900\\/20:is(.dark *) {
  background-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:bg-yellow-950\\/20:is(.dark *) {
  background-color: rgb(66 32 6 / 0.2);
}

.dark\\:from-amber-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(120 53 15 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(120 53 15 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-600:is(.dark *) {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(30 58 138 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-900\\/50:is(.dark *) {
  --tw-gradient-from: rgb(30 58 138 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-950\\/20:is(.dark *) {
  --tw-gradient-from: rgb(23 37 84 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 37 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-950\\/30:is(.dark *) {
  --tw-gradient-from: rgb(23 37 84 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 37 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(6 78 59 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 78 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-950\\/30:is(.dark *) {
  --tw-gradient-from: rgb(2 44 34 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 44 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-800:is(.dark *) {
  --tw-gradient-from: #1f2937 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-900:is(.dark *) {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(17 24 39 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-900\\/80:is(.dark *) {
  --tw-gradient-from: rgb(17 24 39 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-green-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(20 83 45 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 83 45 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-green-950\\/30:is(.dark *) {
  --tw-gradient-from: rgb(5 46 22 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 46 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-950\\/30:is(.dark *) {
  --tw-gradient-from: rgb(67 20 7 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 20 7 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-950\\/30:is(.dark *) {
  --tw-gradient-from: rgb(59 7 100 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 7 100 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-slate-800:is(.dark *) {
  --tw-gradient-from: #1e293b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 41 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-slate-900\\/50:is(.dark *) {
  --tw-gradient-from: rgb(15 23 42 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-blue-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(30 58 138 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(30 58 138 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-800:is(.dark *) {
  --tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1f2937 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-800\\/80:is(.dark *) {
  --tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(31 41 55 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-950:is(.dark *) {
  --tw-gradient-to: rgb(3 7 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #030712 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-indigo-950\\/20:is(.dark *) {
  --tw-gradient-to: rgb(30 27 75 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(30 27 75 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-blue-900:is(.dark *) {
  --tw-gradient-to: #1e3a8a var(--tw-gradient-to-position);
}

.dark\\:to-blue-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(30 58 138 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-emerald-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(6 78 59 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-gray-800:is(.dark *) {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}

.dark\\:to-gray-900:is(.dark *) {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}

.dark\\:to-gray-900\\/80:is(.dark *) {
  --tw-gradient-to: rgb(17 24 39 / 0.8) var(--tw-gradient-to-position);
}

.dark\\:to-green-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(20 83 45 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-green-950\\/30:is(.dark *) {
  --tw-gradient-to: rgb(5 46 22 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-700:is(.dark *) {
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.dark\\:to-indigo-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(49 46 129 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-900\\/50:is(.dark *) {
  --tw-gradient-to: rgb(49 46 129 / 0.5) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-950\\/30:is(.dark *) {
  --tw-gradient-to: rgb(30 27 75 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-orange-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(124 45 18 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-pink-950\\/30:is(.dark *) {
  --tw-gradient-to: rgb(80 7 36 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-purple-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(88 28 135 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-purple-950\\/20:is(.dark *) {
  --tw-gradient-to: rgb(59 7 100 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-red-950\\/30:is(.dark *) {
  --tw-gradient-to: rgb(69 10 10 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-slate-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(15 23 42 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-teal-950\\/30:is(.dark *) {
  --tw-gradient-to: rgb(4 47 46 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-destructive:is(.dark *) {
  color: hsl(var(--color-destructive));
}

.dark\\:text-error:is(.dark *) {
  color: hsl(var(--color-error));
}

.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-info:is(.dark *) {
  color: hsl(var(--color-info));
}

.dark\\:text-muted-foreground:is(.dark *) {
  color: hsl(var(--color-muted-foreground));
}

.dark\\:text-orange-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary:is(.dark *) {
  color: hsl(var(--color-primary));
}

.dark\\:text-purple-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-success:is(.dark *) {
  color: hsl(var(--color-success));
}

.dark\\:text-warning:is(.dark *) {
  color: hsl(var(--color-warning));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder-gray-400:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}

.dark\\:shadow-primary\\/10:is(.dark *) {
  --tw-shadow-color: hsl(var(--color-primary) / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:ring-amber-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(146 64 14 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-blue-900\\/50:is(.dark *) {
  --tw-ring-color: rgb(30 58 138 / 0.5);
}

.dark\\:ring-red-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 27 27 / var(--tw-ring-opacity, 1));
}

.dark\\:placeholder\\:text-muted-foreground:is(.dark *)::placeholder {
  color: hsl(var(--color-muted-foreground));
}

.dark\\:hover\\:border-blue-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-blue-800:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-success:hover:is(.dark *) {
  border-color: hsl(var(--color-success));
}

.dark\\:hover\\:bg-blue-900\\/20:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:hover\\:bg-blue-900\\/40:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.4);
}

.dark\\:hover\\:bg-blue-950\\/70:hover:is(.dark *) {
  background-color: rgb(23 37 84 / 0.7);
}

.dark\\:hover\\:bg-error-muted\\/20:hover:is(.dark *) {
  background-color: hsl(var(--color-error-muted) / 0.2);
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-green-900\\/20:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:hover\\:bg-green-950\\/70:hover:is(.dark *) {
  background-color: rgb(5 46 22 / 0.7);
}

.dark\\:hover\\:bg-info:hover:is(.dark *) {
  background-color: hsl(var(--color-info));
}

.dark\\:hover\\:bg-info-muted\\/20:hover:is(.dark *) {
  background-color: hsl(var(--color-info-muted) / 0.2);
}

.dark\\:hover\\:bg-muted:hover:is(.dark *) {
  background-color: hsl(var(--color-muted));
}

.dark\\:hover\\:bg-orange-950\\/70:hover:is(.dark *) {
  background-color: rgb(67 20 7 / 0.7);
}

.dark\\:hover\\:bg-primary-muted\\/20:hover:is(.dark *) {
  background-color: hsl(var(--color-primary-muted) / 0.2);
}

.dark\\:hover\\:bg-purple-950\\/70:hover:is(.dark *) {
  background-color: rgb(59 7 100 / 0.7);
}

.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:hover\\:bg-red-950:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-success-muted\\/20:hover:is(.dark *) {
  background-color: hsl(var(--color-success-muted) / 0.2);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-yellow-950\\/30:hover:is(.dark *) {
  background-color: rgb(66 32 6 / 0.3);
}

.dark\\:hover\\:from-blue-700:hover:is(.dark *) {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:hover\\:to-indigo-800:hover:is(.dark *) {
  --tw-gradient-to: #3730a3 var(--tw-gradient-to-position);
}

.dark\\:hover\\:text-error:hover:is(.dark *) {
  color: hsl(var(--color-error));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-muted-foreground:hover:is(.dark *) {
  color: hsl(var(--color-muted-foreground));
}

.dark\\:hover\\:text-warning:hover:is(.dark *) {
  color: hsl(var(--color-warning));
}

.dark\\:focus\\:border-info\\/40:focus:is(.dark *) {
  border-color: hsl(var(--color-info) / 0.4);
}

.dark\\:focus\\:bg-gray-800:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:ring-blue-400\\/20:focus:is(.dark *) {
  --tw-ring-color: rgb(96 165 250 / 0.2);
}

.group:hover .dark\\:group-hover\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {

  .sm\\:bottom-2 {
    bottom: 0.5rem;
  }

  .sm\\:left-2 {
    left: 0.5rem;
  }

  .sm\\:right-2 {
    right: 0.5rem;
  }

  .sm\\:top-2 {
    top: 0.5rem;
  }

  .sm\\:top-36 {
    top: 9rem;
  }

  .sm\\:m-4 {
    margin: 1rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-8 {
    height: 2rem;
  }

  .sm\\:h-\\[calc\\(100vh-9rem\\)\\] {
    height: calc(100vh - 9rem);
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-7 {
    width: 1.75rem;
  }

  .sm\\:w-8 {
    width: 2rem;
  }

  .sm\\:w-96 {
    width: 24rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .sm\\:pl-8 {
    padding-left: 2rem;
  }

  .sm\\:pr-8 {
    padding-right: 2rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  .md\\:m-4 {
    margin: 1rem;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:w-28 {
    width: 7rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1024px) {

  .lg\\:fixed {
    position: fixed;
  }

  .lg\\:inset-auto {
    inset: auto;
  }

  .lg\\:top-0 {
    top: 0px;
  }

  .lg\\:z-40 {
    z-index: 40;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:m-6 {
    margin: 1.5rem;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:max-w-lg {
    max-width: 32rem;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:transform-none {
    transform: none;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }

  .lg\\:bg-card {
    background-color: hsl(var(--color-card));
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:m-8 {
    margin: 2rem;
  }

  .xl\\:max-w-2xl {
    max-width: 42rem;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:gap-8 {
    gap: 2rem;
  }

  .xl\\:p-10 {
    padding: 2.5rem;
  }

  .xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B,CAA1B;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,yCAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;EAA1B,+DAA0B;EAA1B;IAAA,qCAA0B;IAA1B,qCAA0B;IAA1B,yBAA0B;IAA1B,+CAA0B;IAA1B,+BAA0B;IAA1B,qDAA0B;IAA1B,+BAA0B;IAA1B,qDAA0B;IAA1B,mCAA0B;IAA1B,yDAA0B;IAA1B,2BAA0B;IAA1B,iDAA0B;IAA1B,6BAA0B;IAA1B,mDAA0B;IAA1B,uCAA0B;IAA1B,6DAA0B;IAA1B,6BAA0B;IAA1B,2BAA0B;IAA1B,yBAA0B;IAA1B,iBAA0B;;IAA1B,mDAA0B;IAA1B,+CAA0B;IAA1B,iDAA0B;IAA1B,+CAA0B;IAA1B,8CAA0B;EAAA;;EAA1B;IAAA,yDAA0B;IAA1B,qCAA0B;IAA1B,qCAA0B;IAA1B,yBAA0B;IAA1B,+CAA0B;IAA1B,+BAA0B;IAA1B,qDAA0B;IAA1B,+BAA0B;IAA1B,qDAA0B;IAA1B,mCAA0B;IAA1B,yDAA0B;IAA1B,2BAA0B;IAA1B,iDAA0B;IAA1B,6BAA0B;IAA1B,mDAA0B;IAA1B,uCAA0B;IAA1B,6DAA0B;IAA1B,6BAA0B;IAA1B,2BAA0B;IAA1B,yBAA0B;;IAA1B,0CAA0B;IAA1B,+CAA0B;IAA1B,iDAA0B;IAA1B,+CAA0B;IAA1B,6FAA0B;EAAA;EAA1B;EAAA;AAA0B;EAA1B;EAAA,8CAA0B;EAA1B,mCAA0B;IAA1B;AAA0B;AAC1B;EAAA,sBAAgC;EAAhC,6BAAgC;EAAhC,4BAAgC;EAAhC,8BAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,QAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,2BAA+B;IAA/B;EAA+B;;EAA/B;IAAA,eAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,iFAA+B;EAA/B,iFAA+B;EAA/B;AAA+B;AAA/B;EAAA,uFAA+B;EAA/B,iFAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,8EAA+B;EAA/B;AAA+B;AAA/B;EAAA,qFAA+B;EAA/B,8EAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kFAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,gFAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA,kDAA+B;EAA/B;AAA+B;AAA/B;EAAA,mDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kGAA+B;EAA/B;AAA+B;AAA/B;EAAA,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,0DAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,+QAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,+QAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B,+QAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,+QAA+B;EAA/B;AAA+B;AAA/B;EAAA,+QAA+B;EAA/B;AAA+B;AAA/B;EAAA,gKAA+B;EAA/B,wJAA+B;EAA/B,iLAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,mCAA+B;IAA/B;EAA+B;AAAA;AAA/B;;EAAA;IAAA,kCAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA,qBAA+B;EAA/B,yBAA+B;EAA/B,2BAA+B;EAA/B,yBAA+B;EAA/B,0BAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAw1B7B;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;AAgBA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;AAEA;IACE;MACE,gBAAgB;IAClB;EACF;AAEA;IACE;MACE,gBAAgB;IAClB;EACF;AA93BF;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AA0E/B,kCAAkC;AAClC;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE,oDAAoD;IACpD,mBAAmB;EACrB;EACA;IACE,oDAAoD;IACpD,sBAAsB;EACxB;AACF;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA;EACE,mBAAmB,uBAAuB,EAAE;EAC5C,qBAAqB,wBAAwB,EAAE;EAC/C,MAAM,uBAAuB,EAAE;AACjC;;AAEA;EACE,qBAAqB,mBAAmB,EAAE;EAC1C,WAAW,sBAAsB,EAAE;AACrC;;AAEA;EACE,WAAW,4DAA4D,EAAE;EACzE,MAAM,6DAA6D,EAAE;AACvE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA,6BAA6B;AAE3B;EAAA,wBAAuE;EAAvE,wDAAuE;EAAvE,0BAAuE;EAAvE;AAAuE;AAAvE;EAAA,yBAAuE;EAAvE,+LAAuE;EAAvE,gFAAuE;EAAvE,oGAAuE;EAAvE;AAAuE;AADzE;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAE1B;EAAA,4EAAkD;EAAlD,4DAAkD;EAAlD,mEAAkD;EAAlD,mEAAkD;EAAlD;AAAkD;;AAIlD;EAAA,4EAAoD;EAApD,4DAAoD;EAApD,mEAAoD;EAApD,mEAAoD;EAApD;AAAoD;;AAIpD;EAAA,4EAAsD;EAAtD,4DAAsD;EAAtD,oEAAsD;EAAtD,mEAAsD;EAAtD;AAAsD;;AAItD;EAAA,4EAAgD;EAAhD,4DAAgD;EAAhD,mEAAgD;EAAhD,mEAAgD;EAAhD;AAAgD;;AAIhD;EAAA,4EAAsD;EAAtD,4DAAsD;EAAtD,mEAAsD;EAAtD,mEAAsD;EAAtD;AAAsD;;AAItD;EAAA,4EAAoD;EAApD,4DAAoD;EAApD,mEAAoD;EAApD,mEAAoD;EAApD;AAAoD;;AAGtD,2BAA2B;AAEzB;EAAA,wBAAkC;EAAlC,wDAAkC;EAAlC,0BAAkC;EAAlC;AAAkC;;AAIlC;EAAA,yBAA+B;EAA/B,+LAA+B;EAA/B,gFAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;;AAI/B;EAAA,wBAAkC;EAAlC,wDAAkC;EAAlC,0BAAkC;EAAlC;AAAkC;;AAGpC;EACE,gEAAgE;AAClE;;AAGE;EAAA,8BAAwC;EAAxC,wDAAwC;EAAxC,0BAAwC;EAAxC;AAAwC;;AAIxC;EAAA,kBAAgB;EAAhB,kBAAgB;EAAhB;AAAgB;;AAGlB,gCAAgC;AAE9B;EAAA,qEAAoH;EAApH,4DAAoH;EAApH,qEAAoH;EAApH,mEAAoH;EAApH,sEAAoH;EAApH,4GAAoH;EAApH;AAAoH;AAApH;EAAA,4DAAoH;EAApH,kEAAoH;EAApH,mEAAoH;EAApH,mEAAoH;EAApH,4GAAoH;EAApH;AAAoH;AADtH;EAEE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,4BAA4B;AAE1B;EAAA,qEAAmD;EAAnD,4DAAmD;EAAnD,oEAAmD;EAAnD,mEAAmD;EAAnD,wDAAmD;EACnD;AADmD;;AAIrD;EACE,OAAO,SAAS,EAAE;AACpB;;AAEA,qBAAqB;AACrB;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,yBAAyB;AAEvB;EAAA,qEAA2F;EAA3F,4DAA2F;EAA3F,mEAA2F;EAA3F,mEAA2F;EAA3F;AAA2F;AAA3F;EAAA,4DAA2F;EAA3F,mEAA2F;EAA3F,mEAA2F;EAA3F;AAA2F;AAC3F;EAAA,wBAAyE;EAAzE,wDAAyE;EAAzE,0BAAyE;EAAzE;AAAyE;AAAzE;EAAA,2BAAyE;EAAzE,+LAAyE;EAAzE,+EAAyE;EAAzE,mGAAyE;EAAzE;AAAyE;;AAIzE;EAAA,qEAA+F;EAA/F,4DAA+F;EAA/F,mEAA+F;EAA/F,mEAA+F;EAA/F;AAA+F;;AAA/F;EAAA,4DAA+F;EAA/F,mEAA+F;EAA/F,mEAA+F;EAA/F;AAA+F;;AAC/F;EAAA,wBAAyE;EAAzE,wDAAyE;EAAzE,0BAAyE;EAAzE;AAAyE;;AAAzE;EAAA,2BAAyE;EAAzE,+LAAyE;EAAzE,+EAAyE;EAAzE,mGAAyE;EAAzE;AAAyE;;AAIzE;EAAA,qEAA+F;EAA/F,4DAA+F;EAA/F,mEAA+F;EAA/F,mEAA+F;EAA/F;AAA+F;;AAA/F;EAAA,4DAA+F;EAA/F,mEAA+F;EAA/F,mEAA+F;EAA/F;AAA+F;;AAC/F;EAAA,wBAAyE;EAAzE,wDAAyE;EAAzE,0BAAyE;EAAzE;AAAyE;;AAAzE;EAAA,2BAAyE;EAAzE,+LAAyE;EAAzE,+EAAyE;EAAzE,mGAAyE;EAAzE;AAAyE;;AAIzE;EAAA,qEAAqF;EAArF,4DAAqF;EAArF,mEAAqF;EAArF,mEAAqF;EAArF;AAAqF;;AAArF;EAAA,4DAAqF;EAArF,mEAAqF;EAArF,mEAAqF;EAArF;AAAqF;;AACrF;EAAA,wBAAyE;EAAzE,wDAAyE;EAAzE,0BAAyE;EAAzE;AAAyE;;AAAzE;EAAA,2BAAyE;EAAzE,+LAAyE;EAAzE,+EAAyE;EAAzE,mGAAyE;EAAzE;AAAyE;;AAG3E,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,gCAAgC;AAClC;;AAEA,0BAA0B;AAExB;EAAA,qEAA8E;EAA9E,8EAA8E;EAA9E,8EAA8E;EAA9E,mEAA8E;EAA9E,wDAA8E;EAA9E,6BAA8E;UAA9E,qBAA8E;EAA9E;AAA8E;;AAGhF,yBAAyB;AAEvB;EAAA,iBAAgG;EAAhG,oCAAgG;EAAhG,wCAAgG;EAAhG,8BAAgG;EAAhG,+QAAgG;EAAhG;AAAgG;AAAhG;EAAA,oCAAgG;EAAhG;AAAgG;;AAGlG,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAGE;EAAA;AAAe;;AAIf;EAAA,qBAA6B;EAA7B;AAA6B;;AAI7B;EAAA;AAA0B;;AAG5B,yBAAyB;AACzB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,iDAAiD;EACjD,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,2DAA2D;AAC7D;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uCAAuC;EACvC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0DAA6K;EAC7K,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,2FAA2F;EAC3F,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,iBAAiB,EAAE;AAC3B;;AAEA,uBAAuB;AACvB;EACE,4HAA4H;EAC5H,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,mHAAmH;EACnH,0BAA0B;AAC5B;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,+BAA+B;;AAx1B/B;EAAA;AAk4BA;;AAl4BA;EAAA,0BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,yBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,iBAk4BA;EAl4BA,iBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,oEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,oEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,gDAk4BA;EAl4BA,6DAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,+EAk4BA;EAl4BA,mGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,6EAk4BA;EAl4BA,iGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,0CAk4BA;EAl4BA,uDAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,gFAk4BA;EAl4BA,oGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,gCAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,8BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,2GAk4BA;EAl4BA,yGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,8BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,2GAk4BA;EAl4BA,yGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,2GAk4BA;EAl4BA,yGAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,qBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,2BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,0BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,yBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,iBAk4BA;EAl4BA,iBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,iBAk4BA;EAl4BA,iBAk4BA;EAl4BA;AAk4BA;;AAl4BA;;EAAA;IAAA;EAk4BA;AAAA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;;EAAA;IAAA;EAk4BA;AAAA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,yEAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,yEAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,yEAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,uEAk4BA;EAl4BA,iEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,uEAk4BA;EAl4BA,iEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,uEAk4BA;EAl4BA,iEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,uEAk4BA;EAl4BA,iEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,yEAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,wEAk4BA;EAl4BA,kEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,iEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,2BAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kDAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,sBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,4DAk4BA;EAl4BA,mEAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA;AAk4BA;;AAl4BA;EAAA,kBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;EAAA,oBAk4BA;EAl4BA;AAk4BA;;AAl4BA;;EAAA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,sDAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,uDAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,2DAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,+DAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,4DAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,eAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;AAAA;;AAl4BA;;EAAA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,2DAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,eAk4BA;IAl4BA;EAk4BA;AAAA;;AAl4BA;;EAAA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,qBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,uDAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,uBAk4BA;IAl4BA,4DAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,oBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,eAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,eAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;AAAA;;AAl4BA;;EAAA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA;EAk4BA;;EAl4BA;IAAA,iBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,mBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,kBAk4BA;IAl4BA;EAk4BA;;EAl4BA;IAAA,eAk4BA;IAl4BA;EAk4BA;AAAA;;AAl4BA;;EAAA;IAAA;EAk4BA;AAAA","sourcesContent":["@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n@import \"./design-system.css\";\n\n@layer base {\n  /* Legacy CSS Custom Properties - Mapped to new design system */\n  :root {\n    --background: var(--color-background);\n    --foreground: var(--color-foreground);\n    --card: var(--color-card);\n    --card-foreground: var(--color-card-foreground);\n    --popover: var(--color-popover);\n    --popover-foreground: var(--color-popover-foreground);\n    --primary: var(--color-primary);\n    --primary-foreground: var(--color-primary-foreground);\n    --secondary: var(--color-secondary);\n    --secondary-foreground: var(--color-secondary-foreground);\n    --muted: var(--color-muted);\n    --muted-foreground: var(--color-muted-foreground);\n    --accent: var(--color-accent);\n    --accent-foreground: var(--color-accent-foreground);\n    --destructive: var(--color-destructive);\n    --destructive-foreground: var(--color-destructive-foreground);\n    --border: var(--color-border);\n    --input: var(--color-input);\n    --ring: var(--color-ring);\n    --radius: 0.75rem;\n\n    /* Document Analysis Specific Variables - Updated */\n    --doc-primary-gradient: var(--gradient-primary);\n    --doc-secondary-gradient: var(--gradient-success);\n    --doc-success-gradient: var(--gradient-success);\n    --doc-accent-gradient: var(--gradient-rainbow);\n  }\n\n  .dark {\n    /* Legacy mapping maintained for backward compatibility */\n    --background: var(--color-background);\n    --foreground: var(--color-foreground);\n    --card: var(--color-card);\n    --card-foreground: var(--color-card-foreground);\n    --popover: var(--color-popover);\n    --popover-foreground: var(--color-popover-foreground);\n    --primary: var(--color-primary);\n    --primary-foreground: var(--color-primary-foreground);\n    --secondary: var(--color-secondary);\n    --secondary-foreground: var(--color-secondary-foreground);\n    --muted: var(--color-muted);\n    --muted-foreground: var(--color-muted-foreground);\n    --accent: var(--color-accent);\n    --accent-foreground: var(--color-accent-foreground);\n    --destructive: var(--color-destructive);\n    --destructive-foreground: var(--color-destructive-foreground);\n    --border: var(--color-border);\n    --input: var(--color-input);\n    --ring: var(--color-ring);\n\n    /* Dark mode document analysis gradients */\n    --doc-primary-gradient: var(--gradient-primary);\n    --doc-secondary-gradient: var(--gradient-success);\n    --doc-success-gradient: var(--gradient-success);\n    --doc-accent-gradient: linear-gradient(135deg, #434343 0%, hsl(var(--color-background)) 100%);\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n    font-feature-settings: \"rlig\" 1, \"calt\" 1;\n  }\n}\n\n/* Custom animations and effects */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideIn {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes slideInFromRight {\n  from { transform: translateX(100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n@keyframes gentle-bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-4px); }\n}\n\n@keyframes pulse-glow {\n  0%, 100% { \n    box-shadow: 0 0 20px hsl(var(--color-primary) / 0.3);\n    transform: scale(1);\n  }\n  50% { \n    box-shadow: 0 0 30px hsl(var(--color-primary) / 0.5);\n    transform: scale(1.02);\n  }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n@keyframes spin-slow {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes scale-in {\n  from { transform: scale(0.8); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n@keyframes wiggle {\n  0%, 7%, 14%, 21% { transform: rotate(4deg); }\n  3.5%, 10.5%, 17.5% { transform: rotate(-4deg); }\n  25% { transform: rotate(0deg); }\n}\n\n@keyframes heart-beat {\n  0%, 40%, 80%, 100% { transform: scale(1); }\n  20%, 60% { transform: scale(1.15); }\n}\n\n@keyframes glow {\n  0%, 100% { filter: drop-shadow(0 0 5px hsl(var(--color-primary) / 0.5)); }\n  50% { filter: drop-shadow(0 0 20px hsl(var(--color-primary) / 0.8)); }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out;\n}\n\n.animate-slide-in {\n  animation: slideIn 0.3s ease-out;\n}\n\n.animate-slide-in-right {\n  animation: slideInFromRight 0.4s ease-out;\n}\n\n.animate-slide-up {\n  animation: slideUp 0.4s ease-out;\n}\n\n.animate-gentle-bounce {\n  animation: gentle-bounce 0.6s ease-in-out;\n}\n\n.animate-pulse-glow {\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n.animate-float {\n  animation: float 3s ease-in-out infinite;\n}\n\n.animate-spin-slow {\n  animation: spin-slow 3s linear infinite;\n}\n\n.animate-scale-in {\n  animation: scale-in 0.3s ease-out;\n}\n\n.animate-wiggle {\n  animation: wiggle 1s ease-in-out;\n}\n\n.animate-heart-beat {\n  animation: heart-beat 1.5s ease-in-out infinite;\n}\n\n.animate-glow {\n  animation: glow 2s ease-in-out infinite;\n}\n\n/* Interactive card effects */\n.interactive-card {\n  @apply transition-all duration-300 hover:shadow-xl hover:-translate-y-2;\n  position: relative;\n  overflow: hidden;\n}\n\n.interactive-card:hover {\n  animation: gentle-bounce 0.6s ease-in-out;\n}\n\n.interactive-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    hsl(var(--color-foreground) / 0.1),\n    transparent\n  );\n  transition: left 0.5s;\n}\n\n.interactive-card:hover::before {\n  left: 100%;\n}\n\n/* Exam board themed cards */\n.board-card-cambridge {\n  @apply bg-gradient-to-br from-blue-900 to-blue-600;\n}\n\n.board-card-sat {\n  @apply bg-gradient-to-br from-indigo-800 to-blue-500;\n}\n\n.board-card-edexcel {\n  @apply bg-gradient-to-br from-purple-700 to-purple-500;\n}\n\n.board-card-ap {\n  @apply bg-gradient-to-br from-red-700 to-red-500;\n}\n\n.board-card-ib {\n  @apply bg-gradient-to-br from-orange-800 to-orange-600;\n}\n\n.board-card-k12 {\n  @apply bg-gradient-to-br from-green-700 to-green-500;\n}\n\n/* Enhanced hover effects */\n.hover-lift {\n  @apply transition-all duration-300;\n}\n\n.hover-lift:hover {\n  @apply -translate-y-2 shadow-xl;\n}\n\n.hover-glow {\n  @apply transition-all duration-300;\n}\n\n.hover-glow:hover {\n  filter: drop-shadow(0 10px 20px hsl(var(--color-primary) / 0.3));\n}\n\n.hover-scale {\n  @apply transition-transform duration-300;\n}\n\n.hover-scale:hover {\n  @apply scale-105;\n}\n\n/* Loading skeleton animations */\n.skeleton {\n  @apply bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700;\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n}\n\n@keyframes skeleton-loading {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Progress bar animations */\n.progress-bar {\n  @apply bg-gradient-to-r from-blue-500 to-purple-600;\n  animation: progress-fill 1s ease-out;\n}\n\n@keyframes progress-fill {\n  from { width: 0%; }\n}\n\n/* Badge animations */\n.badge-pulse {\n  animation: badge-pulse 2s infinite;\n}\n\n@keyframes badge-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n/* Button hover effects */\n.btn-primary {\n  @apply bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700;\n  @apply transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5;\n}\n\n.btn-success {\n  @apply bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700;\n  @apply transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5;\n}\n\n.btn-warning {\n  @apply bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600;\n  @apply transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5;\n}\n\n.btn-danger {\n  @apply bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600;\n  @apply transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5;\n}\n\n/* Shimmer effect for loading states */\n.shimmer {\n  position: relative;\n  overflow: hidden;\n}\n\n.shimmer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.4),\n    transparent\n  );\n  animation: shimmer 1.5s infinite;\n}\n\n/* Gradient text utility */\n.gradient-text {\n  @apply bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent;\n}\n\n/* Glassmorphism effect */\n.glass {\n  @apply backdrop-blur-lg bg-white/10 dark:bg-black/10 border border-white/20 dark:border-white/10;\n}\n\n/* Custom scrollbar */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  @apply bg-muted;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  @apply bg-border rounded-full;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  @apply bg-muted-foreground;\n}\n\n/* Line clamp utilities */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.line-clamp-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Document Analysis Enhanced Styles */\n.doc-analysis-container {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n.dark .doc-analysis-container {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n}\n\n.doc-analysis-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.dark .doc-analysis-header {\n  background: rgba(34, 34, 34, 0.95);\n  border-bottom: 1px solid hsl(var(--color-foreground) / 0.1);\n}\n\n/* Tab Navigation Animations */\n.doc-tab-nav {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 8px;\n  box-shadow: 0 8px 32px hsl(var(--color-background) / 0.1);\n}\n\n.dark .doc-tab-nav {\n  background: rgba(34, 34, 34, 0.8);\n}\n\n.doc-tab-button {\n  position: relative;\n  padding: 12px 24px;\n  border-radius: 12px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.doc-tab-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: var(--doc-primary-gradient);\n  transition: left 0.4s ease;\n  z-index: -1;\n}\n\n.doc-tab-button:hover::before {\n  left: 0;\n}\n\n.doc-tab-button.active {\n  background: var(--doc-primary-gradient);\n  color: white;\n  transform: scale(1.05);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.doc-tab-button:hover {\n  transform: translateY(-2px);\n  color: white;\n}\n\n/* Interactive Cards */\n.doc-interactive-card {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .doc-interactive-card {\n  background: rgba(42, 42, 42, 0.9);\n  border: 1px solid hsl(var(--color-foreground) / 0.1);\n}\n\n.doc-interactive-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--doc-primary-gradient);\n  transform: scaleX(0);\n  transition: transform 0.4s ease;\n}\n\n.doc-interactive-card:hover::before {\n  transform: scaleX(1);\n}\n\n.doc-interactive-card:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n}\n\n/* Enhanced Chat Interface */\n.doc-chat-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dark .doc-chat-container {\n  background: rgba(42, 42, 42, 0.95);\n  border: 1px solid hsl(var(--color-foreground) / 0.1);\n}\n\n.doc-chat-message {\n  padding: 16px 20px;\n  margin: 8px 0;\n  border-radius: 18px;\n  max-width: 85%;\n  position: relative;\n  animation: messageSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.doc-chat-message.user {\n  background: var(--doc-primary-gradient);\n  color: white;\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.doc-chat-message.ai {\n  background: rgba(241, 245, 249, 0.8);\n  color: #334155;\n  align-self: flex-start;\n  border: 1px solid rgba(226, 232, 240, 0.5);\n}\n\n.dark .doc-chat-message.ai {\n  background: rgba(51, 51, 51, 0.8);\n  color: #e2e8f0;\n  border: 1px solid hsl(var(--color-foreground) / 0.1);\n}\n\n.doc-chat-input {\n  background: rgba(255, 255, 255, 0.9);\n  border: 2px solid rgba(226, 232, 240, 0.5);\n  border-radius: 16px;\n  padding: 16px 20px;\n  transition: all 0.3s ease;\n  resize: none;\n}\n\n.dark .doc-chat-input {\n  background: rgba(51, 51, 51, 0.9);\n  border: 2px solid hsl(var(--color-foreground) / 0.1);\n  color: white;\n}\n\n.doc-chat-input:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);\n  transform: scale(1.01);\n}\n\n/* Game Elements */\n.doc-game-card {\n  background: var(--doc-secondary-gradient);\n  color: white;\n  border-radius: 20px;\n  padding: 24px;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.doc-game-card::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle, hsl(var(--color-foreground) / 0.1) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.doc-game-card:hover::before {\n  opacity: 1;\n}\n\n.doc-game-card:hover {\n  transform: translateY(-8px) scale(1.05);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.doc-drag-item {\n  background: rgba(255, 255, 255, 0.9);\n  border: 2px dashed rgba(102, 126, 234, 0.3);\n  border-radius: 12px;\n  padding: 16px;\n  margin: 8px;\n  cursor: grab;\n  transition: all 0.3s ease;\n}\n\n.doc-drag-item:hover {\n  border-color: #667eea;\n  transform: scale(1.05);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);\n}\n\n.doc-drag-item.dragging {\n  opacity: 0.5;\n  transform: rotate(5deg) scale(1.1);\n  cursor: grabbing;\n}\n\n.doc-drop-zone {\n  background: rgba(241, 245, 249, 0.6);\n  border: 2px dashed rgba(148, 163, 184, 0.5);\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.doc-drop-zone.active {\n  border-color: #22c55e;\n  background: rgba(34, 197, 94, 0.1);\n  transform: scale(1.02);\n}\n\n/* Podcast Player Styling */\n.doc-podcast-player {\n  background: var(--doc-success-gradient);\n  border-radius: 24px;\n  padding: 24px;\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.doc-podcast-player::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><circle cx=\"50\" cy=\"50\" r=\"2\" fill=\"rgba(255,255,255,0.1)\"/></svg>') repeat;\n  opacity: 0.3;\n}\n\n.doc-podcast-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.doc-podcast-progress {\n  flex: 1;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n}\n\n.doc-podcast-progress-bar {\n  height: 100%;\n  background: white;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.doc-podcast-button {\n  width: 48px;\n  height: 48px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.doc-podcast-button:hover {\n  background: hsl(var(--color-foreground) / 0.3);\n  transform: scale(1.1);\n}\n\n/* Mind Map Styling */\n.doc-mindmap-container {\n  background: radial-gradient(circle at center, rgba(102, 126, 234, 0.1) 0%, transparent 70%);\n  border-radius: 20px;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n.doc-mindmap-node {\n  background: rgba(255, 255, 255, 0.9);\n  border: 2px solid rgba(102, 126, 234, 0.3);\n  border-radius: 16px;\n  padding: 16px 20px;\n  position: absolute;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  backdrop-filter: blur(10px);\n}\n\n.dark .doc-mindmap-node {\n  background: rgba(51, 51, 51, 0.9);\n  border-color: rgba(102, 126, 234, 0.5);\n}\n\n.doc-mindmap-node:hover {\n  transform: scale(1.1);\n  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.3);\n  z-index: 10;\n}\n\n.doc-mindmap-connection {\n  stroke: rgba(102, 126, 234, 0.6);\n  stroke-width: 2;\n  fill: none;\n  stroke-dasharray: 5,5;\n  animation: connectionPulse 2s ease-in-out infinite;\n}\n\n@keyframes connectionPulse {\n  0%, 100% { stroke-opacity: 0.6; }\n  50% { stroke-opacity: 1; }\n}\n\n/* Loading Animations */\n.doc-loading-skeleton {\n  background: linear-gradient(90deg, rgba(241, 245, 249, 0.8) 25%, rgba(226, 232, 240, 0.8) 50%, rgba(241, 245, 249, 0.8) 75%);\n  background-size: 200% 100%;\n  animation: skeletonLoading 1.5s ease-in-out infinite;\n  border-radius: 8px;\n}\n\n.dark .doc-loading-skeleton {\n  background: linear-gradient(90deg, rgba(51, 51, 51, 0.8) 25%, rgba(68, 68, 68, 0.8) 50%, rgba(51, 51, 51, 0.8) 75%);\n  background-size: 200% 100%;\n}\n\n@keyframes skeletonLoading {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.doc-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(102, 126, 234, 0.2);\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Success and Error States */\n.doc-success-message {\n  background: var(--doc-success-gradient);\n  color: white;\n  padding: 16px 20px;\n  border-radius: 12px;\n  animation: successSlideIn 0.5s ease-out;\n}\n\n@keyframes successSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.doc-error-message {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);\n  color: white;\n  padding: 16px 20px;\n  border-radius: 12px;\n  animation: errorShake 0.5s ease-out;\n}\n\n@keyframes errorShake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n/* Responsive Enhancements */\n@media (max-width: 768px) {\n  .doc-tab-nav {\n    padding: 4px;\n    margin: 0 16px;\n  }\n  \n  .doc-tab-button {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n  \n  .doc-chat-container {\n    min-height: 400px;\n    margin: 16px;\n  }\n  \n  .doc-interactive-card {\n    margin: 8px;\n  }\n  \n  .doc-game-card {\n    padding: 16px;\n  }\n  \n  .doc-mindmap-node {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n}\n\n/* Title truncation utilities */\n@layer utilities {\n  .title-truncate-short {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 150px;\n  }\n  \n  .title-truncate-medium {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 200px;\n  }\n  \n  .title-truncate-long {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 300px;\n  }\n  \n  .title-truncate-responsive {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 120px;\n  }\n  \n  @media (min-width: 640px) {\n    .title-truncate-responsive {\n      max-width: 200px;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .title-truncate-responsive {\n      max-width: 300px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
